/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CureItemToServiceView',["CureItemToServiceData","CureItemToService","CureItemToServiceUsageView", "CureItemToServiceUsageData",
        "CureItemToServiceUsage","CureItemToServiceUsageSrv", "$filter",
        function (CureItemToServiceData,CureItemToService,CureItemToServiceUsageView,CureItemToServiceUsageData,
                  CureItemToServiceUsage,CureItemToServiceUsageSrv,$filter)
        {

        var CureItemToServiceView = function (cureItemToService,ciIndex,cureItemView,domainView)
        {
            this.ciIndex = ciIndex; //model index
            this.domainView = domainView;
            this.cureItemView = cureItemView;
            this.serviceView =null;
            this.quantity =0;
            this.usedQuantity =0;
            this.cureItemToServiceUsagesView = [];

            if (cureItemToService)
                this.loadDataFrom(cureItemToService);
        };
        CureItemToServiceView.prototype.getModel = function()
        {
            if (this.ciIndex!=-1)
            {
                return CureItemToServiceData.getByIndex(this.ciIndex);
            }
            return null;
        };
        CureItemToServiceView.prototype.loadDataFrom = function(cureItemToService)
        {
            if (cureItemToService)
            {
                this.quantity = cureItemToService.quantity;
                if (cureItemToService.service && this.domainView && this.domainView.getServiceView!==undefined)
                    this.serviceView = this.domainView.getServiceView(cureItemToService.service);



                var  cureItemToServiceUsageView;
                this.cureItemToServiceUsagesView = [];
                for (var i=0;i<cureItemToService.cureItemToServiceUsages.length;i++)
                {
                    cureItemToServiceUsageView = new CureItemToServiceUsageView(cureItemToService.cureItemToServiceUsages[i],CureItemToServiceUsageData.getIndexOf(cureItemToService.cureItemToServiceUsages[i]),this,this.domainView);
                    this.cureItemToServiceUsagesView.push(cureItemToServiceUsageView);
                }
                this.updateChronogicalIndexCureItemToServiceUsageView();
                this.updateUsedQuantity();

            }
        };
        CureItemToServiceView.prototype.reloadModel = function() {
            var cureItemToService = this.getModel();
            if (cureItemToService!=null)
            {

                var  cureItemToServiceUsageView;
                var previousCureItemToServiceUsagesView  = this.cureItemToServiceUsagesView
                this.cureItemToServiceUsagesView = [];
                for (var i=0;i<cureItemToService.cureItemToServiceUsages.length;i++)
                {
                    cureItemToServiceUsageView = null;
                    for (var j=0;j<previousCureItemToServiceUsagesView.length &&!cureItemToServiceUsageView;j++)
                        if (previousCureItemToServiceUsagesView[j].getModel()===cureItemToService.cureItemToServiceUsages[i])
                            cureItemToServiceUsageView = previousCureItemToServiceUsagesView[j];
                    if (cureItemToServiceUsageView)
                        cureItemToServiceUsageView.reloadModel();
                    else
                        cureItemToServiceUsageView = new CureItemToServiceUsageView(cureItemToService.cureItemToServiceUsages[i],CureItemToServiceUsageData.getIndexOf(cureItemToService.cureItemToServiceUsages[i]),this,this.domainView);
                    this.cureItemToServiceUsagesView.push(cureItemToServiceUsageView);
                }
                this.updateChronogicalIndexCureItemToServiceUsageView();
                this.updateUsedQuantity();
            }
        }
        CureItemToServiceView.prototype.isUsed = function()
        {
            return this.quantity== this.usedQuantity;
        }
        CureItemToServiceView.prototype.updateUsedQuantity = function()
        {
            this.usedQuantity =0;
            for (var i=0;i<this.cureItemToServiceUsagesView.length;i++)
                this.usedQuantity +=this.cureItemToServiceUsagesView[i].usedQuantity;

        };

        CureItemToServiceView.prototype.copyDataTo = function(cureItemToService)
        {
            if (cureItemToService)
            {
                cureItemToService.quantity = this.quantity;
                if (this.serviceView)
                    cureItemToService.service = this.serviceView.getModel();
                else
                    cureItemToService.service = null;

            }
        };
        CureItemToServiceView.prototype.init = function(cureItemView,cureToServiceView)
        {
            this.cureItemView = cureItemView;
            this.serviceView = cureToServiceView.serviceView;
            this.quantity = cureToServiceView.quantity;
        };
        CureItemToServiceView.prototype.addNewUsage = function()
        {
            var usageView = new CureItemToServiceUsageView(null,-1,this);
            usageView.usageTime = new Date();
            usageView.usedQuantity = 1;
            if (this.domainView && this.domainView.humanResourcesView && this.domainView.humanResourcesView.length>0)
                usageView.hrView = this.domainView.humanResourcesView[0];
            this.cureItemToServiceUsagesView.push(usageView);
            if (this.cureItemView)
                this.cureItemView.useForm.cureItemToServiceUsagesView.push(usageView);
            this.updateUsedQuantity();
            this.updateChronogicalIndexCureItemToServiceUsageView();

        };
        CureItemToServiceView.prototype.hasCureItemUsage = function()
        {
            var hasUsage = false;
            for (var i=0;i<this.cureItemToServiceUsagesView.length&&!hasUsage;i++)
                hasUsage = this.cureItemToServiceUsagesView[i].usedQuantity !=0 ;
            return hasUsage;
        };
        CureItemToServiceView.prototype.removeUsageView = function(usageView)
        {
            if (usageView)
            {
                var index = this.cureItemToServiceUsagesView.indexOf(usageView);
                if (index!=-1)
                    this.cureItemToServiceUsagesView.splice(index,1);
                if (this.cureItemView)
                {
                    index = this.cureItemView.useForm.cureItemToServiceUsagesView.indexOf(usageView);
                    if (index!=-1)
                        this.cureItemView.useForm.cureItemToServiceUsagesView.splice(index,1);
                }
                this.updateChronogicalIndexCureItemToServiceUsageView();
                this.updateUsedQuantity();
            }
        };
        CureItemToServiceView.prototype.updateModel = function(saveUsage)
        {
            var cureItemToService = this.getModel();
            if (cureItemToService==null)
            {
                cureItemToService = new CureItemToService();
                this.ciIndex = CureItemToServiceData.getIndexOf(cureItemToService);
            }
            else
            {
                var cureItemToServiceUsage=null;
                var newCureItemToServiceUsages = [];
                for (var i=0;i<this.cureItemToServiceUsagesView.length;i++)
                {
                    cureItemToServiceUsage = this.cureItemToServiceUsagesView[i].getModel();
                    if (!cureItemToServiceUsage)//new
                    {
                        cureItemToServiceUsage = new CureItemToServiceUsage(null,null,this.getModel());
                        this.cureItemToServiceUsagesView[i].ciIndex =  CureItemToServiceUsageData.getIndexOf(cureItemToServiceUsage);
                    }
                    if (this.cureItemToServiceUsagesView[i].isChanged())
                    {
                        this.cureItemToServiceUsagesView[i].updateModel(saveUsage);
                    }
                    newCureItemToServiceUsages.push(cureItemToServiceUsage);
                }
                // Check removed and softDelete them
                for (var i=0;i<cureItemToService.cureItemToServiceUsages.length;i++)
                    if(newCureItemToServiceUsages.indexOf(cureItemToService.cureItemToServiceUsages[i])==-1)//remove
                        CureItemToServiceUsageSrv.remove(cureItemToService.cureItemToServiceUsages[i]);

                // Copy new list to current object
                cureItemToService.cureItemToServiceUsages =  newCureItemToServiceUsages;

            }
            this.copyDataTo(cureItemToService);




        };
        CureItemToServiceView.prototype.updateServiceSelectableForCure = function()//
        {
            if (this.serviceView) {
                this.serviceView.nbSelectableForCure += this.quantity - this.usedQuantity;
                return this.serviceView;
            }
            return null;
        };
        CureItemToServiceView.prototype.getCureItemToServiceUsageView= function(cureItemToServiceUsage)
        {
            if (cureItemToServiceUsage)
                for (var i =0;i<this.cureItemToServiceUsagesView.length;i++)
                    if (this.cureItemToServiceUsagesView[i].getModel()===cureItemToServiceUsage)
                        return this.cureItemToServiceUsagesView[i];
            return null;
        };
        CureItemToServiceView.prototype.addUsageFromBookingServiceView = function(bsView)
        {
            if (bsView)
            {
                var cUsageView = new CureItemToServiceUsageView(null,this);
                cUsageView.initFromBookingServiceView(this,bsView);
                this.cureItemToServiceUsagesView.push(cUsageView);
                this.updateUsedQuantity();
                this.updateChronogicalIndexCureItemToServiceUsageView();
            }
        };
        CureItemToServiceView.prototype.updateChronogicalIndexCureItemToServiceUsageView = function()
        {
            var orderedcureItemToServiceUsages = $filter('orderBy')(this.cureItemToServiceUsagesView, 'usageTime');

            for (var i=0;i<orderedcureItemToServiceUsages.length;i++)
            {
                orderedcureItemToServiceUsages[i].chronogicalIndex = (i+1);
            }
        }
        CureItemToServiceView.prototype.addCureItemToServiceUsageView = function(cureItemToServiceUsageView)
        {
            if (cureItemToServiceUsageView)
            {
                var index = this.cureItemToServiceUsagesView.indexOf(cureItemToServiceUsageView);
                if (index==-1)
                    this.cureItemToServiceUsagesView.push(cureItemToServiceUsageView);
                cureItemToServiceUsageView.cureItemToServiceView =this;
                this.updateUsedQuantity();
                this.updateChronogicalIndexCureItemToServiceUsageView();
            }
        };

        CureItemToServiceView.prototype.removeCureItemToServiceUsageView = function(cureItemToServiceUsageView)
        {
            if (cureItemToServiceUsageView)
            {
                var index = this.cureItemToServiceUsagesView.indexOf(cureItemToServiceUsageView);
                if (index!=-1)
                    this.cureItemToServiceUsagesView.splice(index,1);
                //cureItemToServiceUsageView.cureItemToServiceView =null; keep for duplicate
                this.updateUsedQuantity();
                this.updateChronogicalIndexCureItemToServiceUsageView();
            }
        };
        CureItemToServiceView.prototype.initUseForm = function()
        {
            if (this.cureItemView)
            {
                if (this.serviceView && this.cureItemView.useForm.servicesView.indexOf(this.serviceView)==-1)
                    this.cureItemView.useForm.servicesView.push(this.serviceView);
                for (var i =0;i<this.cureItemToServiceUsagesView.length;i++)
                {
                    this.cureItemToServiceUsagesView[i].initUseForm();
                    this.cureItemView.useForm.cureItemToServiceUsagesView.push(this.cureItemToServiceUsagesView[i]);
                }

            }
        };


        return CureItemToServiceView;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/views/CureItemToServiceView.js